module.exports = __webpack_public_path__ + "img/er.c828c446.png";